import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ManualAssessmentType } from '@app/model/enums/manual-assessment-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-manual-assessment-file-upload',
    templateUrl: './manual-assessment-file-upload.component.html',
    styleUrls: ['./manual-assessment-file-upload.component.scss'],
    standalone: false
})
export class ManualAssessmentFileUploadComponent {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  @Output() public fileSelected: EventEmitter<File | File[]> = new EventEmitter();

  @Input() multiple = false;
  @Input() allowedExtensions = '*';
  @Input() maxAllowedFileSizeInMb = 20;
  @Input() assessmentType: ManualAssessmentType;

  public files: File[];

  constructor(
    private readonly translateService: TranslateService,
    private readonly toastr: ToastrService) { }

  public fileChanged(event): void {
    this.files = Array.from(event.target.files);

    if (!this.files) {
      this.fileSelected.emit(null);
    }

    const isValid = this.files.every(file => this.isValidFile(file));

    if (!isValid) {
      return;
    }

    this.emitFiles();
  }

  public deleteFile(): void {
    this.files = null;
    this.emitFiles();

    if (this.fileInput) {
      this.fileInput.nativeElement.value = null;
    }
  }

  private emitFiles(): void {
    this.fileSelected.emit(this.multiple ? this.files : this.files[0])
  }

  private isValidFile(file): boolean {
    const size = file.size / (1024  * 1024);
    const extension = file.name.split('.').reverse()[0];
    const allowedExtensionsArray = this.allowedExtensions.split(' ');
    let error: string;

    if (this.assessmentType === ManualAssessmentType.FILE_UPLOAD && allowedExtensionsArray.indexOf(extension) === -1) {
      error = this.translateService.instant('MANUAL_ASSIGNMENT.media_file_extension_error');
    } else if (size > this.maxAllowedFileSizeInMb) {
      error = this.translateService.instant('MANUAL_ASSIGNMENT.media_file_max_size_error');
    }

    if (error) {
      this.toastr.error(error);
      this.deleteFile();
    }

    return !error;
  }

}
